const CHAT_WIDGET_FAB_DIAMETER = 56;

export const styles = (theme) => ({
    dialogPaper: {
        borderRadius: '16px',
    },
    newsBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        '&:not(:last-of-type)': {
            marginBottom: 3,
        },
    },
    newsIllustration: {
        alignSelf: 'center',
        width: 96,
        height: 96,
        borderRadius: '50%',
        objectFit: 'cover',
    },
    newsTitle: {
        fontWeight: 600,
    },
    newsBody: {
        color: theme.palette.text.secondary,
    },
    pointerContainer: {
        position: 'fixed',
        bottom: 24,
        right: 24,
        width: CHAT_WIDGET_FAB_DIAMETER,
        height: CHAT_WIDGET_FAB_DIAMETER,
        zIndex: theme.zIndex.modal + 2,
        pointerEvents: 'none',
    },
    pointerRing: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: CHAT_WIDGET_FAB_DIAMETER,
        height: CHAT_WIDGET_FAB_DIAMETER,
        borderRadius: '50%',
        border: `3px solid ${theme.palette.warning.main}`,
        animation: 'newsChatPointerPulse 1.6s ease-out infinite',
        '@keyframes newsChatPointerPulse': {
            '0%': {transform: 'translate(-50%, -50%) scale(0.85)', opacity: 1},
            '100%': {transform: 'translate(-50%, -50%) scale(1.6)', opacity: 0},
        },
    },
});
